import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/ui";

const toolsData = {
  "Meetings & Collaboration": [
    {
      name: "Microsoft Teams",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/teams.jpg",
      url: "https://teams.cloud.microsoft/",
    },
    {
      name: "Google Meet",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/gmeet.png",
      url: "https://meet.google.com/landing",
    },
    {
      name: "Zoom",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/zoompng.png",
      url: "https://app.zoom.us/wc",
    },
  ],

  Communication: [
    {
      name: "Mattermost",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/mattermost.png",
      url: "https://lightspeedphotonics-openproject.com/",
    },
    {
      name: "Whatsapp",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/whatsapp.png",
      url: "https://web.whatsapp.com/",
    },
  ],

  "Inventory & Operations": [
    {
      name: "Inventree",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/Inventree.png",
      url: "https://lightspeedphotonics-inventree.com/",
    },
    {
      name: "Microsoft Excel",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/excelpng.webp",
      url: "https://excel.cloud.microsoft/",
    },
  ],

  "Storage & Backup": [
    {
      name: "My Cloud Home",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/mycloudhome.png",
      url: "https://home.mycloud.com/",
    },
    {
      name: "Terramaster-NAS",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/terra.png",
      url: "http://192.168.1.9:8181/tos/",
    },
  ],

  "Payroll & Finance": [
    {
      name: "Razorpay",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/razor.png",
      url: "https://payroll.razorpay.com/",
    },
  ],
  
  "Email Services": [
    {
      name: "Roundcube",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/roundcube.png",
      url: "https://lightspeedphotonics.com/roundcube/",
    },
    {
      name: "Thunderbird",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/thunderbird.png",
      url: "https://www.thunderbird.net/en-US/",
    },
    {
      name: "Outlook",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/outlooksvg.svg",
      url: "https://outlook.office.com/",
    },
    {
      name: "gmail",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/gmail.png",
      url: "https://mail.google.com/",
    },
  ],
  
  "Web Resources": [
    {
      name: "Company Website",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/redlogo.jpeg",
      url: "https://lightspeedphotonics.com/",
    },
  ],

  "Microsoft Services": [
    {
      name: "OneDrive",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/onedrive.png",
      url: "https://lightspeedphotonics-my.sharepoint.com/",
    },
  ],
};

function Tools() {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Business Applications"
        subtitle="Access all company tools, applications and resources from one place."
      />

      {Object.keys(toolsData).map((category) => (
        <section key={category}>
          <h2 className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3">{category}</h2>

          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
            {toolsData[category].map((tool) => (
              <a
                key={tool.name}
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl p-4 hover:border-[#C00000]/50 hover:shadow-sm transition-all"
              >
                <div className="w-11 h-11 shrink-0 rounded-lg border border-gray-100 bg-white flex items-center justify-center">
                  <img src={tool.logo} alt="" className="w-7 h-7 object-contain" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-[#111111] truncate">{tool.name}</p>
                  <p className="text-xs text-gray-400">Open</p>
                </div>
                <ArrowUpRight size={16} className="text-gray-300 group-hover:text-[#C00000] transition-colors" />
              </a>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default Tools;
